/**
 * Deterministic 32-bit string hash (djb2-like) used to fingerprint a metric's
 * metadata so that editing the LLM judge prompt invalidates cached experiment
 * results in sessionStorage. Pure function — same input always yields the same
 * output, order-sensitive via JSON.stringify.
 */
export const hashMetricMetadata = (metadata: unknown): string => {
  const serialized = JSON.stringify(metadata ?? {})
  let hash = 0
  for (let i = 0; i < serialized.length; i++) {
    hash = (hash << 5) - hash + serialized.charCodeAt(i)
    hash |= 0
  }
  return hash.toString(36)
}

/**
 * Build the sessionStorage key for a metric's experiment results. The
 * fingerprint suffix causes stored results to be discarded whenever the
 * metric's metadata changes (e.g. prompt edits).
 */
export const buildExperimentStorageKey = (
  metricId: string | null | undefined,
  metadata: unknown,
  scope?: unknown,
): string => {
  const baseKey = `metric-experiment-results-${metricId || "new"}-${hashMetricMetadata(metadata)}`
  return scope === undefined
    ? baseKey
    : `${baseKey}-${hashMetricMetadata(scope)}`
}
